import MmenuLight from 'mmenu-light'

/*const menu = new MmenuLight(
  document.querySelector('#menu'),
  '(max-width: 1023px)'
)//*/
const menu = new MmenuLight(
  document.querySelector('#menu'),''
)

menu.navigation({
  title: '',
})

const drawer = menu.offcanvas({
  position: 'left',
})

const header_container = document.createElement('div')
header_container.classList.add('container')
document.querySelector('.mm-ocd__content').prepend(header_container)

const mmenu_close_btn = document.createElement('div')
mmenu_close_btn.classList.add('close')
switch(document.documentElement.lang){
  default:
  case 'fr':
    mmenu_close_btn.innerHTML = 'Fermer'
    break
  case 'en':
    mmenu_close_btn.innerHTML = 'Close'
    break
  case 'de':
    mmenu_close_btn.innerHTML = 'Schließe'
    break
  case 'nl':
    mmenu_close_btn.innerHTML = 'Sluiten'
    break
}
mmenu_close_btn.addEventListener('click', () => {
  drawer.close()
})
header_container.prepend(mmenu_close_btn)

const logo = document.querySelector('.o-header-primary .logo-link').cloneNode(true)
header_container.prepend(logo)


document.addEventListener('click', (e) => {
  const target = e.target.closest('.open-menu')
  if (!target) return

  if (!document.body.classList.contains('.mm-ocd-opened')) {
    drawer.open()
  } else {
    drawer.close()
  }
})
